import { useEffect } from 'react'
import { getUserAgent, useMetricTracking } from './useMetricTracking'

export const usePageTracking = () => {
  const { trackMetrics } = useMetricTracking()

  useEffect(() => {
    trackMetrics({
      metrics: [
        {
          metricName: 'page_view',
          value: 1,
          dimensions: [{ name: 'domain', value: window.location.hostname }],
        },
        {
          metricName: 'page_view',
          value: 1,
          dimensions: [{ name: 'user_agent', value: getUserAgent() }],
        },
      ],
    }).catch(error => {
      console.warn('Failed to track page view:', error)
    })
  }, [trackMetrics])
}
